export default "__VITE_ASSET__GpKVsGzI__"